import type { BaseThemeType } from 'opensolar-ui'
import { Box, styled } from 'opensolar-ui'

/** Vertical gap between stacked sections on the wallet manage page. */
export const WALLET_PAGE_SECTION_GAP_PX = 24

export const WalletPageSectionStack = styled(Box, { name: 'WalletPageSectionStack' })({
  display: 'flex',
  flexDirection: 'column',
  gap: WALLET_PAGE_SECTION_GAP_PX,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
})

/** Shared Paper styles for wallet manage page cards (balance, tax, card details). */
export const walletManageCardPaperSx = {
  boxShadow: 'none',
  padding: '20px 24px',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box' as const,
}

export const EMBEDDED_WALLET_SECTION_BACKGROUND = '#F8F8F8'

export const EMBEDDED_WALLET_SHELL_BORDER_RADIUS = 4

/** Grey panel used for embedded wallet sections (integrations modal, tabbed top-up). */
export function walletGreySectionPaperSx(theme: BaseThemeType) {
  return {
    ...walletManageCardPaperSx,
    backgroundColor: EMBEDDED_WALLET_SECTION_BACKGROUND,
    borderRadius: EMBEDDED_WALLET_SHELL_BORDER_RADIUS,
  }
}

const MIN_HEIGHT = 24
const PADDING = '6px 6px';

export const WalletCardFieldShell = styled('div', {
  name: 'WalletCardFieldShell',
  shouldForwardProp: (prop) => prop !== 'cardFieldFocused' && prop !== 'embeddedWalletShell',
})<{ cardFieldFocused?: boolean; embeddedWalletShell?: boolean }>(({ theme, cardFieldFocused, embeddedWalletShell }) => ({
  border: `1px solid ${
    cardFieldFocused ? theme.palette.blue[800] : theme.palette.neutralGrey[500]
  }`,
  borderRadius: embeddedWalletShell ? EMBEDDED_WALLET_SHELL_BORDER_RADIUS : 12,
  padding: PADDING,
  minHeight: MIN_HEIGHT,
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
}))

export const WalletSavedCardRowShell = styled('div', {
  name: 'WalletSavedCardRowShell',
  shouldForwardProp: (prop) => prop !== 'embeddedWalletShell',
})<{ embeddedWalletShell?: boolean }>(({ theme, embeddedWalletShell }) => ({
  border: theme.mixins.borderStandard.border,
  borderRadius: embeddedWalletShell ? EMBEDDED_WALLET_SHELL_BORDER_RADIUS : 12,
  padding: PADDING,
  minHeight: MIN_HEIGHT,
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 8,
  boxSizing: 'border-box',
  width: '100%',
}))
